import { render, staticRenderFns } from "./renew-ticket-detail.vue?vue&type=template&id=20b47fbe&scoped=true&"
import script from "./renew-ticket-detail.vue?vue&type=script&lang=js&"
export * from "./renew-ticket-detail.vue?vue&type=script&lang=js&"
import style0 from "./renew-ticket-detail.vue?vue&type=style&index=0&id=20b47fbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b47fbe",
  null
  
)

export default component.exports